// extracted by mini-css-extract-plugin
module.exports = {"container":"classes_container__3yiRX","infoType":"classes_infoType__1UrJ_","profilePic":"classes_profilePic__22Hg-","skills":"classes_skills__2a-M8"};